module.exports = __webpack_public_path__ + "static/media/mountains.85eace62.jpg";